import { useEffect, useRef } from 'react'

export const useDocumentTitle = (title: string, retainOnUnmount = false) => {
  const defaultTitle = useRef(document.title).current

  useEffect(() => {
    document.title = `${title} — hirehire`
  }, [title])

  useEffect(() => {
    return () => {
      if (!retainOnUnmount) {
        document.title = defaultTitle
      }
    }
  }, [defaultTitle, retainOnUnmount])
}
